function validateDOB() {
    const dobNode = document.getElementById('yearOfBirth');
    if(dobNode) {
        const newValue = dobNode.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1') * 1;
        dobNode.value = Math.min(newValue, new Date().getFullYear())
    }
}

function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
function checkCookie(cname) {
    return getCookie(cname) !== "";
}
$( document ).ready(function() {
    if (sessionStorage.getItem("ageconsent") !== true && checkCookie('rememberageconsent') !== true) {
        $('.c-modal-popup').show();
        $('html,body').addClass('modal-open');
    }

    $('.c-modal-popup__action form input, .c-modal-popup__action form select').on("change keyup paste click", function(){
        if($('.c-modal-popup__action--select option:selected').val() != '' && $('#yearOfBirth').val() != ''){
            $('.c-modal-popup__action-btn').removeAttr("disabled");
            $('.c-modal-popup__action-btn').removeClass("u-button-disabled");
        }else{
            if(!$('.u-button-disabled').length){
                $('.c-modal-popup__action-btn').attr('disabled', true); 
                $('.c-modal-popup__action-btn').addClass("u-button-disabled");
            }
        }
    })

    $('.c-modal-popup__action-btn').click(function(e){
        e.preventDefault();

        $('body').css("opacity", "0");
        var $yearOfBirth = $('.c-modal-popup__action form input').val() * 1;
        var $now = new Date();
        var $currentYear = $now.getFullYear();
        var $country = $('.c-modal-popup__action--select option:selected').val();
        if($country == 'AU' || $country == 'HK'){
            if(($currentYear - $yearOfBirth) >= 18 && ($currentYear - $yearOfBirth) <= 130){
                $('.shopify-section--popup').hide();
                $('html,body').removeClass('modal-open');
                sessionStorage.setItem('ageconsent', 'yes');
                const rememberMeNode = document.getElementById('remember-me');
                if(rememberMeNode && rememberMeNode.checked) {
                    setCookie("rememberageconsent", $country, 365);
                } else {
                    setCookie("rememberageconsent", $country, window.age_gate_expired);
                }
            }else{
                $('.c-modal-popup__action form').hide();
                $('#shopify-section-age-gate .c-modal-popup__failure').removeClass('d-none');
                var $urlToRedirect = 'https://drinkwise.org.au';
                if($('.c-modal-popup__failure--link').length){
                    var $urlToRedirect = $('.c-modal-popup__failure--link').text();
                }
                setTimeout(function(){
                    window.location.href = $urlToRedirect;
                },5000)
            }
        }else if($country == 'JP'){
            if(($currentYear - $yearOfBirth) >= 20 && ($currentYear - $yearOfBirth) <= 130){
                $('.shopify-section--popup').hide();
                $('html,body').removeClass('modal-open');
                sessionStorage.setItem('ageconsent', 'yes');
                const rememberMeNode = document.getElementById('remember-me');
                if(rememberMeNode && rememberMeNode.checked) {
                    setCookie("rememberageconsent", $country, 365);
                } else {
                    setCookie("rememberageconsent", $country, window.age_gate_expired);
                }
            }else{
                $('.c-modal-popup__action form').hide();
                $('#shopify-section-age-gate .c-modal-popup__failure').removeClass('d-none');
                var $urlToRedirect = 'https://drinkwise.org.au';
                if($('.c-modal-popup__failure--link').length){
                    var $urlToRedirect = $('.c-modal-popup__failure--link').text();
                }
                setTimeout(function(){
                    window.location.href = $urlToRedirect;
                },5000)
            }
        }
        else{
            if(($currentYear - $yearOfBirth) >= 21 && ($currentYear - $yearOfBirth) <= 130){
                $('.shopify-section--popup').hide();
                $('html,body').removeClass('modal-open');
                sessionStorage.setItem('ageconsent', $country);
                const rememberMeNode = document.getElementById('remember-me');
                if(rememberMeNode && rememberMeNode.checked) {
                    setCookie("rememberageconsent", $country, 365);
                } else {
                    setCookie("rememberageconsent", $country, window.age_gate_expired);
                }
            }else{
                $('.c-modal-popup__action form').hide();
                $('#shopify-section-age-gate .c-modal-popup__failure').removeClass('d-none');
                var $urlToRedirect = 'https://drinkwise.org.au';
                if($('.c-modal-popup__failure--link').length){
                    var $urlToRedirect = $('.c-modal-popup__failure--link').text();
                }
                setTimeout(function(){
                    window.location.href = $urlToRedirect;
                },5000)
            }
        }

        if ($country == 'NO') {
          window.location.href = 'https://wineinmoderation.eu/';
        } else {
          $('body').css("opacity", "1");
        }
    })

    $(document).keypress(function (e) {
        if(!$('.c-modal-popup__action-btn.u-button-disabled').length){
            if (e.which == 13) {
                $('.c-modal-popup__action-btn').trigger('click');
                return false;    //<---- Add this line
            }
        }
    });
});

if (getCookie("rememberageconsent") == 'NO') {
  window.location.href = 'https://wineinmoderation.eu/';
}